import { createEntityAdapter } from "@reduxjs/toolkit";
import { BaseQueryFn, createApi } from "@reduxjs/toolkit/query/react";
import { AxiosError, AxiosRequestConfig } from "axios";
import { appConstants, ITEMS_PER_PAGE } from "../../../shared/config";
import {
  IBlogResponse,
  IBlogState,
  IPost,
  IPostDetail,
} from "../../../shared/interfaces";
import axios from "../../../shared/services/axios.service";
export const blogAdapter = createEntityAdapter<IPost>({
  selectId: (post) => post.slug,
});

const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: "" }
  ): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data }) => {
    try {
      const result = await axios({ url: baseUrl + url, method, data });
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError as AxiosError;
      return {
        error: { status: err.response?.status, data: err.response?.data },
      };
    }
  };

// Define a service using a base URL and expected endpoints
const blogApi = createApi({
  reducerPath: "api",
  keepUnusedDataFor: 60,
  baseQuery: axiosBaseQuery({
    baseUrl: appConstants.urls.baseUrl,
  }),
  endpoints: (builder) => ({
    getBlog: builder.query<IBlogState, string>({
      query: (page) => ({
        url: `${appConstants.urls.getPosts}?page=${page}&size=${ITEMS_PER_PAGE}`,
        method: "GET",
      }),
      transformResponse: (result: IBlogResponse) => {
        if (!result) {
          return;
        }

        const { posts, ...rest } = result,
          dataSource = result.posts
            // .filter((post) => {
            //   const status = post.properties[NOTION_STATUS_COLUMN] as {
            //     id: string;
            //     name: string;
            //     color: string;
            //   };

            //   return status ? status.name === NOTION_STATUS_PUBLISHED : false;
            // })
            .map((post) => {
              post.slug = `5-things-to-consider-${post.title
                .toLowerCase()
                .replace(/[^\w ]+/g, "")
                .replace(/ +/g, "-")}-${post.id.replace(/-+/g, "")}`;

              return post;
            });

        return {
          ...rest,
          posts: blogAdapter.addMany(blogAdapter.getInitialState(), dataSource),
        };
      },
    }),
    getBlogPost: builder.query<IPostDetail, string>({
      query: (postId: string) => ({
        url: `${appConstants.urls.getPostDetail}/${postId}`,
        method: "GET",
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export default blogApi;
export const { useGetBlogPostQuery } = blogApi;
export const { selectAll: selectAllPosts, selectById: selectPostById } =
  blogAdapter.getSelectors();
